import { FETCH_USER, UPDATE_USER, FETCH_GRAVATAR } from "./types";
import actions from "./actions";
import {
  errorMutations,
  loadingMutations,
  resetErrorsAndLoading,
  getter,
  setter
} from "@/store/utils";

const state = {
  isLoading: false,
  user: {},
  errors: null,
  gravatar: null
};

const getters = {
  getFullName: state => `${state.user.first_name} ${state.user.last_name}`,
  getUser: getter("user"),
  identityLoading: getter("identityLoading"),
  isLoading: getter("isLoading"),
  gravatar: getter("gravatar")
};

const mutations = {
  [FETCH_USER.success](state, { payload }) {
    setter("user", payload)(state);
    resetErrorsAndLoading(state);
  },

  [UPDATE_USER.success](state, { payload }) {
    setter("user", payload)(state);
    resetErrorsAndLoading(state);
  },

  [FETCH_GRAVATAR.success](state, { payload }) {
    setter("gravatar", payload.config.url)(state);
    resetErrorsAndLoading(state);
  },

  [FETCH_GRAVATAR.error](state) {
    setter("gravatar", "")(state);
    resetErrorsAndLoading(state);
  },

  ...loadingMutations([
    FETCH_USER.request,
    UPDATE_USER.request,
    FETCH_GRAVATAR.request
  ]),
  ...errorMutations([FETCH_USER.error, UPDATE_USER.error])
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
